import Box from "@mui/material/Box";
import { Grid, Typography, Stack, Divider, Paper } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const ElectricityForm = ({ generalServices }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          استخدام العقار
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item md={3} sm={4} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>
              {" "}
              استخدام العقار :
            </Typography>
            <Typography>{generalServices?.usePropertyType?.name}</Typography>
          </Stack>
        </Grid>

        <Grid item md={9} sm={4} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}> وصف العقار :</Typography>
            <Typography>{generalServices.propertyDescription} </Typography>
          </Stack>
        </Grid>
        <Grid item md={3} sm={4} xs={12}>
          <Stack direction={"row"} gap={1}>
            <Typography sx={{ fontWeight: "bold" }}>
              نوع التيار الكهربائي :
            </Typography>
            <Typography>
              {generalServices?.electricityVoltageType?.name}{" "}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default ElectricityForm;
